export default "__VITE_ASSET__ovJckqFL__"